import type { DietCatalogDetail } from "@/features/diets/types";

export const getKcalFromMeals = (
  diet: DietCatalogDetail,
  kcal: number,
  meals: string[],
) => {
  const currentCalorifics = diet.calorifics.find(
    (cal) => cal.calories === kcal,
  );

  const selectedMealsKcal = currentCalorifics?.mealsCaloricValue?.reduce(
    (acc, curr) => {
      if (meals.includes(curr.mealId)) {
        return acc + curr.caloricity;
      }
      return acc;
    },
    0,
  );
  return selectedMealsKcal;
};